import { FC } from 'react'
import StandingsHeaderWithConfig from '@sport1/news-styleguide/StandingsHeaderWithConfig'
import { StandingsRowProps } from '@/components/Standings/Row'

const AmericanFootballStandingsHeader: FC<Pick<StandingsRowProps, 'competition'>> = ({
    competition,
}) =>
    competition?.id && ['sr:tournament:31371', 'sr:tournament:34498'].includes(competition.id) ? (
        <StandingsHeaderWithConfig
            columns={[
                {
                    value: 'Sp.',
                    width: [30, 30, 48, 48],
                },
                {
                    value: 'S-N-U',
                    width: [48, 48, 56, 64],
                },
                {
                    value: '%',
                    width: [48, 48, 56, 64],
                },
                {
                    value: '+/-',
                    width: [0, 0, 72, 72],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: 'Diff.',
                    width: [0, 0, 56, 56],
                    display: ['none', 'none', 'flex', 'flex'],
                },
            ]}
        />
    ) : (
        <StandingsHeaderWithConfig
            columns={[
                {
                    value: 'Sp.',
                    width: [30, 30, 48, 48],
                },
                {
                    value: 'S-N-U',
                    width: [48, 48, 56, 64],
                },
                {
                    value: '%',
                    width: [48, 48, 56, 64],
                },
                {
                    value: 'Heim',
                    width: [0, 0, 64, 64],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: 'Gast',
                    width: [0, 0, 64, 64],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: '+/-',
                    width: [0, 0, 72, 72],
                    display: ['none', 'none', 'flex', 'flex'],
                },
                {
                    value: 'Diff.',
                    width: [0, 0, 56, 56],
                    display: ['none', 'none', 'flex', 'flex'],
                },
            ]}
        />
    )

export default AmericanFootballStandingsHeader
